import { Text as RNText } from 'react-native';

import { cn } from './cn';

/** A right-facing chevron glyph (list rows). */
export function Chevron({ className }: { className?: string }) {
  return <RNText className={cn('font-sans text-lg text-faint', className)}>›</RNText>;
}
